<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: '#333'
    },
});

const color = computed(() => props.color);
</script>

<template>
<svg id="_レイヤー_2" data-name="レイヤー 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.13 28.5">
    <g id="menu">
        <g>
            <g>
                <path class="cls-2" d="m.16,28.36v-7.74h1.02l2.43,3.84,2.42-3.84h1.04v7.74h-1.05v-5.98l-2.12,3.41h-.58l-2.13-3.41v5.98H.16Z"/>
                <path class="cls-2" d="m9.88,28.36v-7.74h5.05v.95h-4.04v2.36h3.68v.96h-3.68v2.52h4.17v.95h-5.19Z"/>
                <path class="cls-2" d="m17.5,28.36v-7.74h1.02l4,5.96v-5.96h1.03v7.74h-.98l-4.05-6.07v6.07h-1.02Z"/>
                <path class="cls-2" d="m29.17,28.5c-.94,0-1.67-.26-2.16-.78-.5-.52-.75-1.29-.75-2.32v-4.78h1.04v4.73c0,.72.16,1.25.49,1.61.32.36.79.54,1.39.54s1.06-.18,1.38-.54c.32-.36.48-.9.48-1.61v-4.73h1.04v4.78c0,1.02-.25,1.8-.75,2.32-.5.52-1.22.78-2.15.78Z"/>
            </g>
                <line class="cls-1" x1=".06" y1="4.69" x2="33.06" y2=".5"/>
                <line class="cls-1" x1=".06" y1="11.44" x2="33.06" y2="11.44"/>
        </g>
    </g>
</svg>
</template>

<style scoped>
.cls-1 {
    fill: none;
    stroke: v-bind(color);
    stroke-miterlimit: 10;
}

.cls-2 {
    fill: v-bind(color);
    stroke-width: 0px;
}
</style>